<ng-template #template>
  <ng-container [ngSwitch]="model.textSize">
    <h2 *ngSwitchCase="'large'" class="descriptiveText">
      <ng-container *ngTemplateOutlet="elementTitleContent"></ng-container>
    </h2>
    <h3 *ngSwitchCase="'medium'" class="descriptiveText">
      <ng-container *ngTemplateOutlet="elementTitleContent"></ng-container>
    </h3>
    <h4 *ngSwitchCase="'small'" class="descriptiveText">
      <ng-container *ngTemplateOutlet="elementTitleContent"></ng-container>
    </h4>
  </ng-container>
</ng-template>

<ng-template #elementTitleContent>
  <!-- When editor mode -->
  <div class="col-12" style="padding: 0px">
    <div
      class="row"
      *ngIf="getMode() === 'create'"
      style="margin: 0px !important"
    >
      <!-- <p>{{model | json}}</p> -->
      <div class="col-12" style="padding: 0px">
        <p class="hypothisis">
          <b class="mb-1">Diagnostic Hypothesis :</b>
          <br />
          <br />
          <sv-ng-string-editor
            [model]="model.locDiagnosis_hypothisis"
          ></sv-ng-string-editor>
        </p>
      </div>
      <div class="col-12" style="padding: 0px">
        <p class="prognosis">
          <b class="mb-1">Prognosis :</b>
          <br />
          <br />
          <sv-ng-string-editor
            [model]="model.locPrognosis"
          ></sv-ng-string-editor>
        </p>
      </div>
      <div class="col-6" style="padding: 0px">
        <p class="score">
          <b>Confidence Score:</b> &nbsp;
          <sv-ng-string [model]="model.locScore"></sv-ng-string>
        </p>
      </div>
      <div class="col-6" style="padding: 0px">
        <p class="icdcode">
          <b class="mr-1">ICD code:</b> &nbsp;&nbsp;
          <sv-ng-string-editor [model]="model.locICDcode"></sv-ng-string-editor>
        </p>
      </div>
    </div>
  </div>
</ng-template>
